var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_581_1784",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_581_1784",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0klEQVR4nO2cvWpUYRCGX38aLbwB/7DXK4gWWqqthXoDauVaOHNccLHRWmM0fbSx0EJ7wYBESWZ29Qa008aEiEKS4shZ/2BRSOLJfjPjPPBC2n3y8Z3lfZMDJEmSJEmSJEkhuv1DIO0M0104mL+HraAaHAPJZ7DWwzQ/VzqRstuG9PUvyb9lz6Xo1kXLyh9Er6TotuERyT+TNPeqToDlFVhX/yqqfFaHV5Db+775VsCybEBkvb7Iss9vMty/Ul6ebjSXYZLe/G6QToF1yYCkektCsgiWu+i83FVONMt0cRE8rsh0Gcm9ejtYv5YXoGM62fpl+JlTtAYV/b9dHaT3UYzmAUEy+f2BYUAGb0XkE1jvlH0YJkmSJEmSjJ+YfccSzMHyxoCYutWQDmAOlmfxRMtTmIP1XsATPQVzsFQBTzTDHKznA4o+B5N/4BJOdP8ozEHzB4qL4ZbTfbsf5jjzaAdI1+KcZl1D7/lOmIT1fSDR72AWltk4ouUFzML6MJDoBzAL6604ovUmzMJyKdCJvgizcP90oBN9CmahwZHigrilVP3DMEtvbk9xQdxSms9imggDAMkizBNhACCLhX/EAYAsFv4RBwCyWPhHHADIYuEfcQAgi4X/KE1ZXloU/2Nc/IdWhAGga7HwjzYAkOXCP9IAQJYL/0gDAFku/CMNAGS58I80AJDlwn+UpjQvLYw3m4ULcENTmhcXppuMnIQbPA8AleXCP9IA0LNe+EcYAMhD4R9hACAPhX+EAYA8FP4RBgDyUPiP0pTnpcXxhkNwR1OelxdXbyxyFu7wOABUHgr/CANA10Ph730AIE+Fv+cBgDwV/p4HAPJU+I/CMlNcIK83MgO3eHptJmkHbrk62Gf8Tbv1j6zimu6Fa1hv2D/Nch3uad5+SDJp+Mq4DdTbEAbqnwDJE7B8LC9XPoDlMSo9XlpLkiRJkiRJkiRJkiQJHPINH+aFXIdTXXMAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDisable);
export default __webpack_public_path__ + "static/media/trashDisable.81f8b2fe05abb506eb0b1270182d0ca4.svg";
export { ForwardRef as ReactComponent };